import { memo } from 'react';
import { Alert, Container } from 'react-bootstrap';

export const MapPage = memo(function MapPage() {
  return (
    <Container fluid className="py-4">
      <h1 className="h3 mb-4">Facilities Map</h1>

      <Alert variant="info">
        <Alert.Heading>Coming Soon</Alert.Heading>
        <p className="mb-0">
          The interactive map view will be available in a future update. This
          feature will display all childcare facilities on a map with clustering
          and filtering capabilities.
        </p>
      </Alert>

      <div
        className="bg-light border rounded d-flex align-items-center justify-content-center"
        style={{ height: '60vh' }}
      >
        <div className="text-center text-muted">
          <i
            className="bi bi-map"
            style={{ fontSize: '4rem', opacity: 0.5 }}
          />
          <p className="mt-3">Map placeholder</p>
        </div>
      </div>
    </Container>
  );
});
